import { useEffect } from "react";
import { BrandMark, Wordmark } from "@cntrl/ui";
import crowd from "./assets/welcome-crowd.jpg";
import { setStatusBarStyle } from "@cntrl/native";
import { openApplyOnline } from "./applyOnline.js";
import styles from "./WelcomeScreen.module.scss";

/**
 * The iOS app's signed-out first screen (ART-346), shown only on a phone nobody has signed in on. No application and
 * no pricing in the app: **Apply online** opens the web form in Safari, **Learn more** opens the four-step tour, and
 * **I already have an account** goes to Log in. A line underneath tells an invited crew member they have nothing to
 * apply for.
 */
export function WelcomeScreen({ onLearnMore, onLogIn }: { onLearnMore: () => void; onLogIn: () => void }) {
  // Outside the mobile shell, which normally sets the status bar: light content over the dark photo, and back to
  // dark content on the way out, because every screen it leads to (the tour, Log in) is light.
  useEffect(() => {
    setStatusBarStyle("light");
    return () => setStatusBarStyle("dark");
  }, []);
  return (
    <main className={styles.screen}>
      <img src={crowd} alt="" aria-hidden="true" className={styles.photo} />
      <div aria-hidden="true" className={styles.shade} />
      <div className={styles.body}>
        <div className={styles.lockup}>
          <BrandMark size={22} decorative className={styles.mark} />
          <Wordmark size={22} />
        </div>

        <div className={styles.copy}>
          <h1 className={styles.title}>
            Take
            <br />
            CNTRL.
          </h1>
          <p className={styles.lead}>
            Releases, shows, content, analytics and merch for the whole team in one ecosystem. Built by artists, for
            artists and their team.
          </p>
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.primary} onClick={() => void openApplyOnline()}>
            Apply online
          </button>
          <p className={styles.note}>We read it personally and reply within 48 hours.</p>
          <button type="button" className={styles.learnMore} onClick={onLearnMore}>
            Learn more <span aria-hidden="true">→</span>
          </button>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.login} onClick={onLogIn}>
            I already have an account
          </button>
          <p className={styles.invited}>Invited to a band or team? Open the link in your invite email.</p>
        </div>
      </div>
    </main>
  );
}
